import { Box } from '@alf/uikit';

import styles from './index.module.css';

const ChatButton = ({ toggleChat }) => {
  return (
    <Box onClick={toggleChat} className={styles.chatButton}>
      <img
        src="/images/snippetsMedia/contact/support_hr.svg"
        alt=""
        className={styles.chatIcon}
      />
      24/7 Support Chat
    </Box>
  );
};

export default ChatButton;
